import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Toro } from '../common/enumerations';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { Organization, OrganizationUpdateModel } from '../models/organization.model';
import { RepresentativeAdd } from '../models/representative-add.model';
import { ToroAccountDetailed } from '../models/toro-account-detailed.model';
import { User } from '../models/user.model';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class AccountApiService extends ApiService {

    constructor(protected http: HttpClient,
        protected apiUrlService: ApiUrlService,
        protected localCacheManager: LocalCacheManager) {
        super(http, localCacheManager);
    }

    getAccountDetailsById(accountId: number): Observable<ToroAccountDetailed> {
        return this.apiRequest(this.apiUrlService.getAccountDetailsUrl(accountId), this.HttpMethod.Get)
            .pipe(
                map((response: any) => {
                    return new ToroAccountDetailed(response);
                }
                )
            );
    }

    getAccountDetails(accountId: number, accountType: Toro.AccountType): Observable<ToroAccountDetailed> {
        return this.apiRequest(this.apiUrlService.getAccountDetailsUrl(accountId), this.HttpMethod.Get)
            .pipe(
                map((response: any) => {
                    return new ToroAccountDetailed(response, accountType);
                }
                )
            );
    }

    updateAccountAddress(accountId: number, organization: Organization): Observable<{ AccountId: number, Organization: Organization, Success: boolean, Error, string }> {
        return this.apiRequest(this.apiUrlService.getUpdateAccountAddressUrl(accountId), this.HttpMethod.Put, new OrganizationUpdateModel(organization));
    }

    deleteAccount(accountId: number): Observable<any> {
        return this.apiRequest(this.apiUrlService.getDeleteAccountUrl(accountId), this.HttpMethod.Post);
    }

    getRepresentatives(accountId: number, organizationId: number): Observable<User[]> {
        return this.apiRequest(this.apiUrlService.getRepresentatives(accountId, organizationId), this.HttpMethod.Get);
    }

    addExistingUserAsRepresentative(accountId: number, representativeToAdd: RepresentativeAdd): Observable<any> {
        const body = {
            Email: representativeToAdd.Email,
            SecretId: representativeToAdd.SecretId
        };

        return this.apiRequest(this.apiUrlService.getAddExistingUserAsRepresentativeUrl(accountId), this.HttpMethod.Post, body);
    }

    addNewUserAsRepresentative(accountId: number, representativeToAdd: RepresentativeAdd): Observable<any> {
        const body = {
            User: { FName: representativeToAdd.FName, LName: representativeToAdd.LName, Email: representativeToAdd.Email },
            Password: representativeToAdd.Password,
            ConfirmPassword: representativeToAdd.ConfirmPassword
        };

        return this.apiRequest(this.apiUrlService.getAddNewUserAsRepresentativeUrl(accountId), this.HttpMethod.Post, body);
    }

    removeRepresentative(userId: number, organizationId: number): Observable<any> {
        return this.apiRequest(this.apiUrlService.getRemoveRepresentativeUrl(userId, organizationId), this.HttpMethod.Post);
    }

    removeSelfAsRepresentative(organizationId: number): Observable<any> {
        return this.apiRequest(this.apiUrlService.getRemoveSelfAsRepresentativeUrl(organizationId), this.HttpMethod.Post);
    }
}
